<template>
  <div class="privacy-overlay">
    <form @submit.prevent="onSubmit()">
      <control-checkbox
        i18nLabel="common.privacyNotice"
        :validation="v$.privacyNotice"
        v-model="privacyNotice"
        :forCaptcha=true
      />
      <button-save i18nMessage="common.privacyNoticeButton" />
    </form>
  </div>
</template>

<script lang="ts">
import { loadRecaptcha } from '@/utils/domUtils';
import { validateAndFocusInvalid } from '@/utils/formUtils';
import { privacyNoticeRequired } from '@/utils/validationUtils';
import useVuelidate from '@vuelidate/core';
import { defineComponent } from 'vue';
import ControlCheckbox from '../controls/ControlCheckbox.vue';
import ButtonSave from '../interaction/ButtonSave.vue';

export default defineComponent({
  name: 'LoadingContainer',
  components: {
    ControlCheckbox,
    ButtonSave
  },
  data() {
    return {
      privacyNotice: false
    }
  },
  setup() {
    return {
      v$: useVuelidate()
    }
  },
  validations() {
    return {
      privacyNotice: {
        privacyNoticeRequired
      }
    }
  },
  methods: {
    onSubmit() {
      validateAndFocusInvalid(this.v$, this.$el)
        .then(() => {
          this.$store.commit('setPrivacyNotice', true)
          loadRecaptcha()
        })
    }
  }
});
</script>
